export default __webpack_public_path__ + "static/media/img-5.7524c50a.png";